import PropTypes from 'prop-types';
import React from 'react';
import { startCase } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import HeadingRow from './HeadingRow';
import TitleRow from './TitleRow';
import DataRow from './DataRow';

function prettyText(value) {
  if (!value) return value;
  const text = value.replace(/_/g, ' ');
  return startCase(text.toLowerCase());
}

export default function ERSTire({ index, tire, showHeading }) {
  const theme = useTheme();

  const styles = {
    table: {
      background: index % 2 === 0 ? 'inherit' : theme.palette.grey[100],
      paddingLeft: '.5rem',
      paddingTop: '.5rem',
    },
  };

  return (
    <div style={styles.table}>
      <TitleRow
        unit={tire.unit}
        tirePosition={tire.tirePosition}
        index={index}
      />
      {showHeading && <HeadingRow />}
      <DataRow
        label="Brand Name"
        order={`${
          tire.order && tire.order.manufacturer ? tire.order.manufacturer : ''
        }
          (${
            tire.order && tire.order.productType ? tire.order.productType : ''
          })`}
        estimate={
          tire.estimate.confirmed
            ? `${tire.estimate.manufacturer} (${tire.estimate.productType})`
            : ''
        }
        invoice={
          tire.invoice.confirmed
            ? `${tire.invoice.manufacturer} (${tire.invoice.productType})`
            : ''
        }
        index={index}
      />
      <DataRow
        label={
          tire.productType === 'Rim Replacement' ? 'Rim Size' : 'Tire Size'
        }
        order={tire.order.tireSize}
        estimate={tire.estimate.confirmed ? tire.estimate.tireSize : ''}
        invoice={tire.invoice.confirmed ? tire.invoice.tireSize : ''}
      />
      <DataRow
        label={
          tire.productType === 'Rim Replacement'
            ? 'Rim Material'
            : 'Tread Pattern'
        }
        order={tire.order.sculptedTreadName ? tire.order.sculptedTreadName : ''}
        estimate={
          tire.estimate.confirmed ? tire.estimate.sculptedTreadName : ''
        }
        invoice={tire.invoice.confirmed ? tire.invoice.sculptedTreadName : ''}
        index={index}
      />
      <DataRow
        label={
          tire.productType === 'Rim Replacement'
            ? 'Rim Condition'
            : 'Tire Condition'
        }
        order={
          tire.order.tireCondition ? prettyText(tire.order.tireCondition) : ''
        }
        estimate={
          tire.estimate.confirmed ? prettyText(tire.estimate.tireCondition) : ''
        }
        invoice={
          tire.invoice.confirmed ? prettyText(tire.invoice.tireCondition) : ''
        }
        index={index}
      />
      <DataRow
        label="Action"
        order={
          tire.order.requestedAction
            ? prettyText(tire.order.requestedAction)
            : ''
        }
        estimate={
          tire.estimate.confirmed
            ? prettyText(tire.estimate.requestedAction)
            : ''
        }
        invoice={
          tire.invoice.confirmed ? prettyText(tire.invoice.requestedAction) : ''
        }
        index={index}
      />
    </div>
  );
}

ERSTire.propTypes = {
  index: PropTypes.number.isRequired,
  tire: PropTypes.node.isRequired,
  showHeading: PropTypes.bool,
};

ERSTire.defaultProps = {
  showHeading: false,
};
